var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1538 1.30378C11.3886 1.30166 11.6164 1.3498 11.8239 1.43759C12.0313 1.52533 12.2181 1.65248 12.3748 1.80922C12.5316 1.96595 12.6587 2.15279 12.7465 2.36016C12.8342 2.56762 12.8824 2.79542 12.8803 3.03022L12.7851 12.6061L10.5797 12.5842L10.6542 5.08903L2.71478 13.0285L1.15527 11.4689L9.09459 3.52963L1.59895 3.60342L1.57724 1.39805L11.1538 1.30378Z",
    fill: "#008731"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external-link.3d53ffd1.svg";
export { ForwardRef as ReactComponent };